export type TNormalizedClinicAsset = {
  asset_id: number;
  s3_key?: string;
  get_url: string;
};

export const normalizeClinicAssets = (
  assets: unknown,
): TNormalizedClinicAsset[] =>
  Array.isArray(assets)
    ? assets.filter(
        (asset): asset is TNormalizedClinicAsset =>
          typeof asset === "object" &&
          asset !== null &&
          typeof (asset as TNormalizedClinicAsset).asset_id === "number" &&
          typeof (asset as TNormalizedClinicAsset).get_url === "string" &&
          (asset as TNormalizedClinicAsset).get_url.length > 0,
      )
    : [];

export const reconcileClinicAssets = ({
  loadedAssets,
  addedAssets,
  removedAssetIds,
}: {
  loadedAssets: TNormalizedClinicAsset[];
  addedAssets: Iterable<TNormalizedClinicAsset>;
  removedAssetIds: ReadonlySet<number>;
}): TNormalizedClinicAsset[] => {
  const addedById = new Map(
    Array.from(addedAssets, (asset) => [asset.asset_id, asset]),
  );
  const reconciledAssets = loadedAssets
    .filter((asset) => !removedAssetIds.has(asset.asset_id))
    .map((asset) => addedById.get(asset.asset_id) ?? asset);
  const loadedAssetIds = new Set(
    reconciledAssets.map((asset) => asset.asset_id),
  );

  for (const addedAsset of addedById.values()) {
    if (
      !removedAssetIds.has(addedAsset.asset_id) &&
      !loadedAssetIds.has(addedAsset.asset_id)
    ) {
      reconciledAssets.push(addedAsset);
    }
  }

  return reconciledAssets;
};
